module.exports = __webpack_public_path__ + "img/1_top1.20d27a24.png";